// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
		paginationType: bcSfFilterConfig.custom.endless_scroll ? 'infinite' : 'default'
	}
};

var isFirstLoad = true;

var bcSfFilterTemplate = {
	// Grid Template
	productGridItemHtml:  	'<div class="product-item {{itemGridClass}}">' +
								'<a class="product-link" href="{{itemUrl}}" id="product-{{itemId}}">' +
									'<div class="product-item__image {{itemHoverClass}}">' +
										'{{itemImages}}' +
										'{{itemQuickViewBtn}}' +
									'</div>' +
									'<div class="product-information">' +
										'{{itemReviews}}' +
										'<h3 class="title">{{itemTitle}}</h3>' +
										'{{itemPrice}}' +
									'</div>' +
								'</a>' +
							'</div>' +
							'{{itemQuickView}}',

	// Pagination Template
	previousActiveHtml: '<span class="prev-page"><a href="{{itemUrl}}" title="">&larr;</a></span>',
	previousDisabledHtml: '',
	nextActiveHtml: '<span class="next-page"><a href="{{itemUrl}}" title="">&rarr;</a></span>',
	nextDisabledHtml: '',
	pageItemHtml: '<span class="curr-page"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></span>',
	pageItemSelectedHtml: '<span class="current">{{itemTitle}}</span>',
	pageItemRemainHtml: "<span>{{itemTitle}}</span>",
	paginateHtml: '<div class="pagination">{{previous}}{{pageItems}}{{next}}</div>',
	// Sorting Template
	sortingHtml: '<select aria-label="Sort by">{{sortingItems}}</select>'
};

BCSfFilter.prototype.buildProductGridItem = function(data,index,totalProduct) {
	/*** Prepare data ***/
	var images = data.images_info;
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	/*** End Prepare data ***/

	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;

	// Add custom class
	var itemGridClass = "";
	switch (bcSfFilterConfig.custom.products_per_row) {
		case 2:
			itemGridClass = "small--one-half medium--one-half large-up--one-half";
			break;
		case 3:
			itemGridClass = "small--one-whole medium--one-third large-up--one-third";
			break;
		case 4:
			itemGridClass = "small--one-half medium--one-half large-up--one-quarter";
			break;
		case 5:
			itemGridClass = "small--one-half medium--one-third large-up--one-fifth";
			break;
		default:
			itemGridClass = "small--one-half medium--one-third large-up--one-sixth";
			break;
	}
	itemHtml = itemHtml.replace(/{{itemGridClass}}/g, itemGridClass);

	// Add price
	var itemPriceHtml = '';
	if (onSale) {
		itemPriceHtml += '<span class="price sale">';
	} else {
		itemPriceHtml += '<span class="price">';
	}
	if (!soldOut) {
		if (onSale) {
			itemPriceHtml += '<span class="old-price">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span>';
		}
		if (priceVaries) {
			itemPriceHtml += '<small>' + bcSfFilterConfig.label.from + '</small> ';
			itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
		} else {
			itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
		}
	} else {
		itemPriceHtml += '<span class="sold-out">' + bcSfFilterConfig.label.sold_out + '</span>';
	}
	itemPriceHtml += '</span>';
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	// Add item Images
	var itemImagesHtml = '';
	var itemHoverClass = images.length > 1 && bcSfFilterConfig.custom.image_hover_enable ? 'double__image' : '';
	var animation = (index - 1) % bcSfFilterConfig.custom.grid_int;
	var dataBgset = images.length > 0 ? bgset(images[0]) : bcSfFilterConfig.general.no_image_url;
	itemImagesHtml += '<div class="product-item__bg lazyload" ' +
							'data-aos="img-in" ' +
							'data-aos-anchor=".product-grid" ' +
							'data-aos-delay="{{animationDelay}}" ' +
							'data-aos-duration="{{animationDuration}}" ' +
							'data-aos-easing="ease-out-quart" ' +
							'data-bgset="' + dataBgset + '">';
	itemImagesHtml += '</div>';
	if (images.length > 1 && bcSfFilterConfig.custom.image_hover_enable) {
		itemImagesHtml += '<div class="product-item__bg__under lazyload" data-bgset="' + bgset(images[1]) + '"></div>';
	}
	itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, itemHoverClass);
	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
	itemHtml = itemHtml.replace(/{{animationDelay}}/g, animation * 150);
	itemHtml = itemHtml.replace(/{{animationDuration}}/g, animation * 100 + 800);

	// Add Thumbnail
	var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]["src"], "500x") : bcSfFilterConfig.general.no_image_url;
	itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

	// Add Reviews
	var itemReviews = '';
	if (bcSfFilterConfig.custom.enable_reviews){
		if (bcSfFilterConfig.custom.enable_yotpo && bcSfFilterConfig.custom.yotpo_ID){
			itemReviews = '<div class="yotpo bottomLine" data-product-id="{{itemId}}"></div>';
		} else {
			itemReviews = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
	}
	itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);
	
	// Add QuickView
	var itemQuickViewHtml = '';
	var itemQuickViewBtnHtml = '';
	if (onSale) {
		itemQuickViewBtnHtml += '<span class="sale-box">' + bcSfFilterConfig.label.sale + '</span>';
	}
	if (bcSfFilterConfig.custom.quickview_enable) {
		itemQuickViewBtnHtml += '<div class="slideup">';
		itemQuickViewBtnHtml += '<span data-modal="Product' + (index - 1) + '' + parseInt(this.queryParams.page) + '-collection" class="trigger-quick-view caps">' + bcSfFilterConfig.label.quick_view + '</span>';
		itemQuickViewBtnHtml += '</div>';
		
		itemQuickViewHtml += '<div class="modal__overlay quicklook" id="Product' + (index - 1) + '' + parseInt(this.queryParams.page) + '-collection">';
		itemQuickViewHtml += '<section data-boost-theme-quickview="{{itemId}}" class="modal__outer">';
		itemQuickViewHtml += '</section>';
		itemQuickViewHtml += '</div>';
	}
	itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);
	itemHtml = itemHtml.replace(/{{itemQuickViewBtn}}/g, itemQuickViewBtnHtml);

	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

	return itemHtml;
};

function bgset(image) {
	var bgset = '';
	if (image) {
		var aspect_ratio = image.width / image.height;

		if (image.width > 180) bgset += ' ' + bcsffilter.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
		if (image.width > 360) bgset += ' ' + bcsffilter.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
		if (image.width > 540) bgset += ' ' + bcsffilter.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
		if (image.width > 720) bgset += ' ' + bcsffilter.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
		if (image.width > 900) bgset += ' ' + bcsffilter.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
		if (image.width > 1080) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
		if (image.width > 1296) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
		if (image.width > 1512) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
		if (image.width > 1728) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
		if (image.width > 1950) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
		if (image.width > 2100) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
		if (image.width > 2260) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
		if (image.width > 2450) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
		if (image.width > 2700) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
		if (image.width > 3000) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
		if (image.width > 3350) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
		if (image.width > 3750) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
		if (image.width > 4100) bgset += ' ' + bcsffilter.optimizeImage(image.src, '4100x') + ' 4100x ' + Math.round(4100 / aspect_ratio) + 'h,';
		bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
	}
	return bgset;
}

BCSfFilter.prototype.buildPagination = function(totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.pagination).html("");
		return false;
	}
	if (this.getSettingValue("general.paginationType") == "default") {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;
		// Build Previous
		var previousHtml = currentPage > 1 ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink("page", currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = currentPage < totalPage ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink("page", currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift("...");
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push("...");
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = "";
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == "...") {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += pageArr[iPage] == currentPage ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink("page", currentPage, pageArr[iPage])
			);
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		paginationHtml = jQ.parseHTML(paginationHtml);
		jQ(this.selector.pagination).html(paginationHtml);
	}
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
	if (bcSfFilterTemplate.hasOwnProperty("sortingHtml")) {
		jQ(this.selector.topSorting).html("");

		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content
			var sortingItemsHtml = "";
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + "</option>";
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			html = html.replace(/{{itemLabelActive}}/g, sortingArr[this.queryParams.sort]);
			html = jQ.parseHTML(html);
			jQ(this.selector.topSorting).html(html);

			// Set current value
			var label = jQ.parseHTML(sortingArr[this.queryParams.sort]);
			jQ(this.selector.topSorting + " .selected-text strong").html(label);
			jQ(this.selector.topSorting + " select").val(this.queryParams.sort);
		}
	}
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  // Call function to get extra product html by ajax
  if (bcSfFilterConfig.custom.quickview_enable) {
	var sections = new slate.Sections();
    this.buildExtrasProductListByAjax(data, 'boost-integration', function(results){
      results.forEach(function(result, index){
		// Append the custom html to product item
		var html = jQ.parseHTML(result.quickview_html);
        jQ('[data-boost-theme-quickview="'+ result.id+ '"]').html(html);
		if(index == results.length -1){
        	sections.register('collection', [theme.Collection, theme.ProductGrid, theme.Hero]);
			window.Shopify.PaymentButton.init();
        }
      })
    })
  }
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data) {};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData=function(data){var self=this;var countData=data.length;for(var k=0;k<countData;k++){data[k]["images"]=data[k]["images_info"];if(data[k]["images"].length>0){data[k]["featured_image"]=data[k]["images"][0]}else{data[k]["featured_image"]={src:bcSfFilterConfig.general.no_image_url,width:"",height:"",aspect_ratio:0}}data[k]["url"]="/products/"+data[k].handle;var optionsArr=[];var countOptionsWithValues=data[k]["options_with_values"].length;for(var i=0;i<countOptionsWithValues;i++){optionsArr.push(data[k]["options_with_values"][i]["name"])}data[k]["options"]=optionsArr;var firstVariant=data[k]["variants"][0];var isRoundedPrice=true;if(firstVariant.hasOwnProperty("fulfillment_service")&&firstVariant.fulfillment_service=="gift_card"){isRoundedPrice=false}if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){data[k].price_min=self.convertPriceBasedOnActiveCurrency(data[k].price_min,isRoundedPrice);data[k].price_max=self.convertPriceBasedOnActiveCurrency(data[k].price_max,isRoundedPrice);data[k].compare_at_price_min=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_min,isRoundedPrice);data[k].compare_at_price_max=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_max,isRoundedPrice)}data[k]["price_min"]*=100,data[k]["price_max"]*=100;if(data[k]["compare_at_price_min"]!=null){data[k]["compare_at_price_min"]*=100}if(data[k]["compare_at_price_max"]!=null){data[k]["compare_at_price_max"]*=100}data[k]["price"]=data[k]["price_min"];data[k]["compare_at_price"]=data[k]["compare_at_price_min"];data[k]["price_varies"]=data[k]["price_min"]!=data[k]["price_max"];if(getParam("variant")!==null&&getParam("variant")!=""){var paramVariant=data[k]["variants"].filter(function(e){return e.id==getParam("variant")});if(typeof paramVariant[0]!=="undefined")firstVariant=paramVariant[0]}else{var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){if(data[k]["variants"][i].available){firstVariant=data[k]["variants"][i];break}}}data[k]["selected_or_first_available_variant"]=firstVariant;var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){var variantOptionArr=[];var count=1;var variant=data[k]["variants"][i];var variantOptions=variant["merged_options"];if(Array.isArray(variantOptions)){var countVariantOptions=variantOptions.length;for(var j=0;j<countVariantOptions;j++){var temp=variantOptions[j].split(":");data[k]["variants"][i]["option"+(parseInt(j)+1)]=temp[1];data[k]["variants"][i]["option_"+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]["variants"][i]["options"]=variantOptionArr}if(data[k]["variants"][i]["compare_at_price"]!=null){var variantCompareAtPrice=parseFloat(data[k]["variants"][i]["compare_at_price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantCompareAtPrice=self.convertPriceBasedOnActiveCurrency(variantCompareAtPrice,isRoundedPrice)}data[k]["variants"][i]["compare_at_price"]=variantCompareAtPrice*100}var variantPrice=parseFloat(data[k]["variants"][i]["price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantPrice=self.convertPriceBasedOnActiveCurrency(variantPrice,isRoundedPrice)}data[k]["variants"][i]["price"]=variantPrice*100}data[k]["description"]=data[k]["content"]=data[k]["body_html"];if(data[k].hasOwnProperty("original_tags")&&data[k]["original_tags"].length>0){data[k]["tags"]=data[k]["original_tags"].slice(0)}data[k]["json"]=customizeJsonProductData(data[k])}return data};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */

// Set queryParams from address bar and settings
BCSfFilter.prototype.updateApiParams = function(url) {
    // Get Filter params
    var params = this.getFilterParams(url);
    // Revert price param to default currency
    params = this.revertPriceParams(params);
    // Set default params if missing from url params
    params = this.setDefaultParams(params);
    // Remove currency param
    if (params.hasOwnProperty('currency')) {
        delete params.currency;
    }
    // Remove currency rate param
    if (params.hasOwnProperty('currency_rate')) {
        delete params.currency_rate;
    }
    // Boost 223017 Hide products having tag pfs:hidden:search from search results
    if (bcSfFilterConfig.general.template === 'search') {
      params.h_options = params.h_options ? params.h_options.concat('search') : ['search'];
    }
    // Set data back to queryParams
    this.queryParams = params;
};
